module.exports = __webpack_public_path__ + "static/media/proposal_verification_audio.be4b15b5.mp3";